import type { CandidateConfig } from '../../types/config.ts';
import { CandidateToken } from '../common/CandidateToken.tsx';
import { fmtInt, fmtPercent, ratio } from '../../lib/format.ts';

/** One candidate's share as a labeled horizontal bar. The figures are real text
 *  (tabular); the bar is aria-hidden decoration. Only the fill width tweens
 *  (reduced-motion zeroes it via the CSS token). */
export function BarRow({
  candidate,
  color,
  percent,
  votes,
  max = 100,
  leading = false,
}: {
  candidate: CandidateConfig;
  color: string;
  percent: number | null;
  votes: number | null;
  max?: number;
  leading?: boolean;
}) {
  const width = ratio(percent, max) * 100;
  return (
    <div className={`bar-row${leading ? ' bar-row--leading' : ''}`}>
      <div className="bar-row__head">
        <CandidateToken candidate={candidate} color={color} />
        <span className="bar-row__figures" data-numeric>
          <span className="bar-row__pct">{fmtPercent(percent)}</span>
          <span className="bar-row__votes dim">{fmtInt(votes)}</span>
        </span>
      </div>
      <div className="bar-row__track" aria-hidden="true">
        <div
          className="bar-row__fill"
          style={{ width: `${width}%`, ['--cand-color' as string]: color }}
        />
      </div>
    </div>
  );
}
